"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var shell_utils_1 = require("./shell-utils");
/**
 * A shell is the primary interface that is used to start other programs.
 * It's purpose to handle:
 * - Job control (control of child processes),
 * - Control Sequences (CTRL+C to kill the foreground process)
 * - Line editing and history
 * - Output text to the tty -> terminal
 * - Interpret text within the tty to launch processes and interpret programs
 */
var WasmShell = /** @class */ (function () {
    function WasmShell(wasmTerminalConfig, wasmTty, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        /**
         * Move cursor at given direction
         */
        this.handleCursorMove = function (dir) {
            if (dir > 0) {
                var num = Math.min(dir, _this.wasmTty.getInput().length - _this.wasmTty.getCursor());
                _this.wasmTty.setCursorDirectly(_this.wasmTty.getCursor() + num);
            }
            else if (dir < 0) {
                var num = Math.max(dir, -_this.wasmTty.getCursor());
                _this.wasmTty.setCursorDirectly(_this.wasmTty.getCursor() + num);
            }
        };
        /**
         * Erase a character at cursor location
         */
        this.handleCursorErase = function (backspace) {
            if (backspace) {
                if (_this.wasmTty.getCursor() <= 0)
                    return;
                var newInput = _this.wasmTty.getInput().substr(0, _this.wasmTty.getCursor() - 1) +
                    _this.wasmTty.getInput().substr(_this.wasmTty.getCursor());
                _this.wasmTty.clearInput();
                _this.wasmTty.setCursorDirectly(_this.wasmTty.getCursor() - 1);
                _this.wasmTty.setInput(newInput, true);
            }
            else {
                var newInput = _this.wasmTty.getInput().substr(0, _this.wasmTty.getCursor()) +
                    _this.wasmTty.getInput().substr(_this.wasmTty.getCursor() + 1);
                _this.wasmTty.setInput(newInput);
            }
        };
        /**
         * Insert character at cursor location
         */
        this.handleCursorInsert = function (data) {
            var newInput = _this.wasmTty.getInput().substr(0, _this.wasmTty.getCursor()) +
                data +
                _this.wasmTty.getInput().substr(_this.wasmTty.getCursor());
            _this.wasmTty.setCursorDirectly(_this.wasmTty.getCursor() + data.length);
            _this.wasmTty.setInput(newInput);
        };
        /**
         * Handle input completion
         */
        this.handleReadComplete = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._activePrompt && this._activePrompt.resolve) {
                    // TODO: Need to do stuff with this in a promise
                    this._activePrompt.resolve(this.wasmTty.getInput() + '\n');
                    this._activePrompt = undefined;
                }
                this.wasmTty.print('\r\n');
                this._active = false;
                return [2 /*return*/];
            });
        }); };
        /**
         * Handle terminal -> tty input
         */
        this.handleTermData = function (data) {
            // Only Allow CTRL+C Through
            if (!_this._active && data !== "\x03") {
                return;
            }
            if (_this.wasmTty.getFirstInit() && _this._activePrompt) {
                var line = _this.wasmTty
                    .getBuffer()
                    .getLine(_this.wasmTty.getBuffer().cursorY + _this.wasmTty.getBuffer().baseY);
                var promptRead = line.translateToString(false, 0, _this.wasmTty.getBuffer().cursorX);
                _this._activePrompt.promptPrefix = promptRead;
                _this.wasmTty.setPromptPrefix(promptRead);
                _this.wasmTty.setFirstInit(false);
            }
            // If we have an active character prompt, satisfy it in priority
            if (_this._activeCharPrompt && _this._activeCharPrompt.resolve) {
                _this._activeCharPrompt.resolve(data);
                _this._activeCharPrompt = undefined;
                // this.wasmTty.print("\r\n");
                return;
            }
            // If this looks like a pasted input, expand it
            if (data.length > 3 && data.charCodeAt(0) !== 0x1b) {
                var normData = data.replace(/[\r\n]+/g, "\r");
                Array.from(normData).forEach(function (c) { return _this.handleData(c); });
            }
            else {
                _this.handleData(data);
            }
        };
        /**
         * Handle a single piece of information from the terminal -> tty.
         */
        this.handleData = function (data) {
            // Only Allow CTRL+C Through
            if (!_this._active && data !== "\x03") {
                return;
            }
            var ord = data.charCodeAt(0);
            var ofs;
            // Handle ANSI escape sequences
            if (ord === 0x1b) {
                switch (data.substr(1)) {
                    case "[A": // Up arrow
                        break;
                    case "[B": // Down arrow
                        break;
                    case "[D": // Left Arrow
                        _this.handleCursorMove(-1);
                        break;
                    case "[C": // Right Arrow
                        _this.handleCursorMove(1);
                        break;
                    case "[3~": // Delete
                        _this.handleCursorErase(false);
                        break;
                    case "[F": // End
                        _this.wasmTty.setCursor(_this.wasmTty.getInput().length);
                        break;
                    case "[H": // Home
                        _this.wasmTty.setCursor(0);
                        break;
                    // case "b": // ALT + a
                    case "b": // ALT + LEFT
                        ofs = (0, shell_utils_1.closestLeftBoundary)(_this.wasmTty.getInput(), _this.wasmTty.getCursor());
                        if (ofs)
                            _this.wasmTty.setCursor(ofs);
                        break;
                    case "f": // ALT + RIGHT
                        ofs = (0, shell_utils_1.closestRightBoundary)(_this.wasmTty.getInput(), _this.wasmTty.getCursor());
                        if (ofs)
                            _this.wasmTty.setCursor(ofs);
                        break;
                    case "\x7F": // CTRL + BACKSPACE
                        ofs = (0, shell_utils_1.closestLeftBoundary)(_this.wasmTty.getInput(), _this.wasmTty.getCursor());
                        if (ofs) {
                            _this.wasmTty.setInput(_this.wasmTty.getInput().substr(0, ofs) +
                                _this.wasmTty.getInput().substr(_this.wasmTty.getCursor()));
                            _this.wasmTty.setCursor(ofs);
                        }
                        break;
                }
                // Handle special characters
            }
            else if (ord < 32 || ord === 0x7f) {
                switch (data) {
                    case "\r": // ENTER
                    case "\x0a": // CTRL+J
                    case "\x0d": // CTRL+M
                        _this.handleReadComplete();
                        break;
                    case "\x7F": // BACKSPACE
                    case "\x08": // CTRL+H
                    case "\x04": // CTRL+D
                        _this.handleCursorErase(true);
                        break;
                    case "\t": // TAB
                        _this.handleCursorInsert("    ");
                        break;
                    case "\x01": // CTRL+A
                        _this.wasmTty.setCursor(0);
                        break;
                    case "\x02": // CTRL+B
                        _this.handleCursorMove(-1);
                        break;
                    case "\x03": // CTRL+C
                    case "\x1a": // CTRL+Z
                        var currentInput = _this.wasmTty.getInput();
                        _this.wasmTty.setCursor(currentInput.length);
                        _this.wasmTty.setInput("");
                        _this.wasmTty.setCursorDirectly(0);
                        _this.wasmTty.print(currentInput + "^C\r\n");
                        // // Kill the command
                        // if (this.commandRunner) {
                        //   this.commandRunner.kill();
                        //   this.commandRunner = undefined;
                        // }
                        // If we are prompting, then we want to cancel the current read
                        _this.resolveActiveRead();
                        break;
                    case "\x05": // CTRL+E
                        _this.wasmTty.setCursor(_this.wasmTty.getInput().length);
                        break;
                    case "\x06": // CTRL+F
                        _this.handleCursorMove(1);
                        break;
                    case "\x07": // CTRL+G
                        _this.wasmTty.setInput("");
                        break;
                    case "\x0b": // CTRL+K
                        _this.wasmTty.setInput(_this.wasmTty.getInput().substring(0, _this.wasmTty.getCursor()));
                        _this.wasmTty.setCursor(_this.wasmTty.getInput().length);
                        break;
                    case "\x0c": // CTRL+L
                        _this.wasmTty.clearTty();
                        _this.wasmTty.print("$ ".concat(_this.wasmTty.getInput()));
                        break;
                    case "\x0e": // CTRL+N
                        break;
                    case "\x10": // CTRL+P
                        break;
                    case "\x15": // CTRL+U
                        _this.wasmTty.setInput(_this.wasmTty.getInput().substring(_this.wasmTty.getCursor()));
                        _this.wasmTty.setCursor(0);
                        break;
                }
                // Handle visible characters
            }
            else {
                _this.handleCursorInsert(data);
            }
        };
        var optionValues = __assign({ historySize: 10, maxAutocompleteEntries: 100, disablePrompt: false }, options);
        this.wasmTerminalConfig = wasmTerminalConfig;
        this.wasmTty = wasmTty;
        this.maxAutocompleteEntries = optionValues.maxAutocompleteEntries;
        this.disablePrompt = optionValues.disablePrompt;
        this._active = false;
    }
    WasmShell.prototype.prompt = function () {
        return __awaiter(this, void 0, void 0, function () {
            var line, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // If we are already prompting, do nothing...
                        if (this._activePrompt || this.disablePrompt) {
                            return [2 /*return*/, ''];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this._activePrompt = this.wasmTty.read("");
                        this._active = true;
                        return [4 /*yield*/, this._activePrompt.promise];
                    case 2:
                        line = _a.sent();
                        return [2 /*return*/, line];
                    case 3:
                        e_1 = _a.sent();
                        this.wasmTty.println("".concat(e_1));
                        // tslint:disable-next-line
                        this.prompt();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WasmShell.prototype.isPrompting = function () {
        return this._active;
    };
    /**
     * This function completes the current input, calls the given callback
     * and then re-displays the prompt.
     */
    WasmShell.prototype.printAndRestartPrompt = function (callback) {
        var _this = this;
        // Complete input
        this.wasmTty.setCursor(this.wasmTty.getInput().length);
        this.wasmTty.print("\r\n");
        // Prepare a function that will resume prompt
        var resume = function () {
            _this.wasmTty.setCursor(_this.wasmTty.getCursor());
            _this.wasmTty.setInput(_this.wasmTty.getInput());
        };
        // Call the given callback to echo something, and if there is a promise
        // returned, wait for the resolution before resuming prompt.
        var ret = callback();
        if (ret) {
            // tslint:disable-next-line
            ret.then(resume);
        }
        else {
            resume();
        }
    };
    /**
     * Resolve a pending read operation
     * (Will resolve an empty string)
     */
    WasmShell.prototype.resolveActiveRead = function () {
        // Abort the read if we were reading
        if (this._activePrompt && this._activePrompt.resolve) {
            this._activePrompt.resolve("");
            this._activePrompt = undefined;
        }
        if (this._activeCharPrompt && this._activeCharPrompt.resolve) {
            this._activeCharPrompt.resolve("");
            this._activeCharPrompt = undefined;
        }
        this._active = false;
    };
    /**
     * Abort a pending read operation
     */
    WasmShell.prototype.rejectActiveRead = function (reason) {
        if (reason === void 0) { reason = "aborted"; }
        if (this._activePrompt || this._activeCharPrompt) {
            this.wasmTty.print("\r\n");
        }
        if (this._activePrompt && this._activePrompt.reject) {
            this._activePrompt.reject(new Error(reason));
            this._activePrompt = undefined;
        }
        if (this._activeCharPrompt && this._activeCharPrompt.reject) {
            this._activeCharPrompt.reject(new Error(reason));
            this._activeCharPrompt = undefined;
        }
        this._active = false;
    };
    return WasmShell;
}());
exports.default = WasmShell;
